
import { Header } from "@/components/speaking/Header";
import { Topics } from "@/components/speaking/Topics";
import { FormatOptions } from "@/components/speaking/FormatOptions";
import { ReachOut } from "@/components/speaking/ReachOut";
import { Asterisk } from "@/components/Asterisk";
import { Footer } from "@/components/Footer";

const Speaking = () => {
  return (
    <main className="min-h-screen bg-white">
      <div className="max-w-6xl mx-auto px-4 pt-20 pb-12">
        <Header />
        <div className="prose prose-h2:text-[62px] prose-h2:font-medium prose-p:text-[22px] max-w-none space-y-16">
          <Topics />
          <FormatOptions />
          <ReachOut />
        </div>
        <Asterisk />
      </div>
      <Footer />
    </main>
  );
};

export default Speaking;
